export const authManager = {
  logout: () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  },

  getToken: () => localStorage.getItem('token'),

  setToken: (token: string) => localStorage.setItem('token', token),

  isAuthenticated: () => !!localStorage.getItem('token')
}; 